module.exports = __webpack_public_path__ + "img/返回箭头.93b021b8.png";